import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import { closeAlert } from '../../../actions/utils';

const Notification = props => {
  const dispatch = useDispatch();
  const notify = (message, kind, timeout) => {
    if (kind === 'info') {
      toast.info(message, { autoClose: timeout });
    } else if (kind === 'warning') {
      toast.warn(message);
    } else if (kind === 'success') {
      toast.success(message, { autoClose: timeout });
    } else if (kind === 'error') {
      toast.error(message, { autoClose: timeout });
    } else {
      toast(message, { autoClose: timeout });
    }
  };

  const silenceToast = () => {
    dispatch(closeAlert());
  };

  useEffect(() => {
    const {
      alert: { message, show, kind, timeout }
    } = props;

    if (show) {
      notify(message, kind, timeout);
      silenceToast();
    }
  });

  return <ToastContainer />;
};

const mapStateToProps = state => {
  const { alert } = state.utils;
  return {
    alert
  };
};

export default connect(mapStateToProps)(Notification);
